enum FrequencyCapUnit {
  Minute = 60,
  Hour = 3600,
  Day = 3600 * 24,
  Week = 3600 * 24 * 7,
  Month = 3600 * 24 * 30,
  Year = 3600 * 24 * 365,
}

export default FrequencyCapUnit;
